module.exports = __webpack_public_path__ + "kh.svg?1060af3c233c835a294a10fb71ce6589";